export default __webpack_public_path__ + "static/media/tesa.c26b1a51.png";